import { t } from "../../../../../utils/i18n";
import React from "react";

const Head = () => (
  <thead className="table-header">
    <tr>
      <th>{t("cards.common.date")}</th>
      <th>{t("cards.common.amount")}</th>
      <th>{t("cards.common.status")}</th>
      <th>{t("cards.loads.loaded_at")}</th>
      <th className="text-center">{t("cards.common.action")}</th>
    </tr>
  </thead>
);

export default Head;
